import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore, CACHE_SIZE_UNLIMITED, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Firebase configuration from environment variables with fallbacks
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase app (client SDK)
const app = initializeApp(firebaseConfig);

// Firestore database instance with optimized cache settings
const db = initializeFirestore(app, {
  cacheSizeBytes: 10 * 1024 * 1024, // 10MB cache limit (reduced from UNLIMITED)
  experimentalForceLongPolling: false,
  ignoreUndefinedProperties: true
});

// Enable Firestore persistence with error handling
// This will significantly reduce read operations by caching data locally
if (typeof window !== "undefined" && db) {
  try {
    // Enable persistence instead of disabling it
    // This caches data locally to reduce server reads
    await enableIndexedDbPersistence(db);
    console.log("Firestore persistence enabled successfully");
  } catch (e) {
    if (e.code === 'failed-precondition') {
      console.warn("Multiple tabs open, persistence can only be enabled in one tab at a time.");
    } else if (e.code === 'unimplemented') {
      console.warn("The current browser does not support persistence.");
    } else {
      console.log("Persistence enable error:", e);
    }
  }
}

// Firebase Auth instance
const auth = getAuth(app);
const functionsService = getFunctions(app);
const storage = getStorage(app);

export { app, db, auth, functionsService, storage };
